// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-templates-project----project-module---wrapper---PT7xQ","container":"src-templates-project----project-module---container---3UN_T"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/project/project.module.css
// module id = 567
// module chunks = 140935043865547